var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-name c-ndarkfour",style:(_vm.small ? 'height: 32px;width: 32px; font-size: 14px;' : '')},[_vm._v(" "+_vm._s(_vm.initialName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }